import vuetify from '@/plugins/vuetify';
import { loadFonts } from '@/plugins/webfontloader';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';
import App from './App.vue';

loadFonts();

const pinia = createPinia();
pinia.use(createPersistedState());

const app = createApp(App).use(vuetify).use(pinia);

app.mount('#app');
